import Table from "react-bootstrap/Table";

const GenericTable = ({
  data,
  renderHeader,
  renderRow,
  className = "",
  onRowClick,
}) => {
  return (
    <Table className={className}>
      {renderHeader()}
      <tbody>
        {data.map((item, index) => (
          <tr
            key={index}
            onClick={onRowClick ? () => onRowClick(item) : undefined}
            style={onRowClick ? { cursor: "pointer" } : {}}
          >
            {renderRow(item, index)}
          </tr>
        ))}
      </tbody>
    </Table>
  );
};

export default GenericTable;
